// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2ssKU","date":"styles_date__2wJUo","btnWrapper":"styles_btnWrapper__3JpEr"};